export enum DestructiveDialogResult {
  CONFIRMED = 'confirmed',
  CANCELED = 'canceled',
}
